module.exports = __webpack_public_path__ + "static/work_BB_BF_loop-e33e3abf257c3abf4e9038764b18e227.mp4";